export default "<p>datasheet-session-editor works!</p>\r\n";